<script>
import axios from 'axios';
import TrainingWidget from './components/TrainingWidget';
import TomWidget from './components/TomWidget';
import ProcedureDirectoryWidget from './components/ProcedureDirectoryWidget';
import AvContractWidget from './components/AvContractWidget';
import TaskWidget from './components/TaskWidget';
import AuditWidget from './components/AuditWidget';

export default {
  name: 'Dashboard',
  components: {
    TrainingWidget,
    TomWidget,
    ProcedureDirectoryWidget,
    AvContractWidget,
    TaskWidget,
    AuditWidget,
  },
  data() {
    return {
      isDisplayed: false,
      renderedId: 0,
    };
  },
  watch: {
    $route(to) {
      if (to.path === '/' || to.path === '/dashboard') {
        this.renderedId += 1;
      }
    },
  },
  mounted() {
    axios.get('/api/roles', {
      params: null,
    })
      .then((response) => {
        const { isReseller } = response.data;
        const { isEmployee } = response.data;
        console.log('response', response);
        console.log('isReseller', isReseller);
        console.log('isEmployee', isEmployee);
        if (!(isReseller || isEmployee)) {
          this.isDisplayed = true;
        } else if (!isReseller && isEmployee) {
          this.$router.push('/training');
        } else {
          this.$router.push('/clients');
        }
      });
  },
};
</script>

<template>
  <div>
    <v-container fluid grid-list-md text-xs-center :key="renderedId" v-if="isDisplayed">
      <v-layout row wrap>
        <v-flex xs12 sm6 md3>
          <training-widget />
        </v-flex>

        <v-flex xs12 sm6 md3>
          <tom-widget />
        </v-flex>

        <v-flex xs12 sm6 md3>
          <procedure-directory-widget />
        </v-flex>

        <v-flex xs12 sm6 md3>
          <av-contract-widget />
        </v-flex>

        <v-flex xs12 sm7>
          <task-widget />
        </v-flex>

        <v-flex xs12 sm5>
          <audit-widget />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style lang="scss">
.v-card {padding:1rem;}
.title{margin-left:20px;font-weight:300;}
h4,h5{font-weight:400;color:#444}
.high{background-color:#D32F2F;}
.normal{background-color:#EF6C00;}
.low{background-color:#CFD8DC;}
.prio{height:95%;width:5px;margin-right:12px;}
</style>

